module.exports = __webpack_public_path__ + "media/semantic/dist/themes/default/assets/fonts/outline-icons-c20b5b7362d8d7bb7eddf94344ace33e.woff2";